import { Typography } from '@material-ui/core';
import type { CockpitRailState } from '../model/cockpitViewModel';
import { formatDurationMs } from '../model/formatters';
import { useCockpitStyles } from './cockpitStyles';
import {
  type EvidenceRailSummary,
  type EvidenceRailTick,
  formatRatio,
  railStateLabel,
} from './evidenceRailPresentation';

export function EvidenceRailSummaryView({
  summary,
}: {
  summary: EvidenceRailSummary;
}) {
  const classes = useCockpitStyles();
  // the window has no share to state — it is the whole of it
  const values: ReadonlyArray<readonly [string, number, number | null]> = [
    ['Janela da atividade', summary.windowMs, null],
    ['Com evidência', summary.evidencedMs, summary.evidencedRatio],
    [
      'Sem sinal registrado',
      summary.withoutSignalMs,
      summary.withoutSignalRatio,
    ],
  ];
  return (
    <dl className={classes.railSummary} aria-label="Recorte temporal observado">
      {values.map(([label, value, ratio]) => (
        <div key={label} className={classes.railSummaryItem}>
          <Typography component="dt" variant="caption">
            {label}
          </Typography>
          <Typography component="dd" variant="body2">
            <span className={classes.railSummaryValue}>
              {formatDurationMs(value)}
            </span>
            {ratio !== null && (
              <span className={classes.railSummaryShare}>
                {formatRatio(ratio)} da janela
              </span>
            )}
          </Typography>
        </div>
      ))}
    </dl>
  );
}

export function EvidenceRailAxis({ ticks }: { ticks: EvidenceRailTick[] }) {
  const classes = useCockpitStyles();
  const tickClass = {
    start: classes.railTickStart,
    middle: classes.railTickMiddle,
    end: classes.railTickEnd,
  };
  return (
    <ol className={classes.railAxis} aria-label="Eixo de tempo da atividade">
      {ticks.map(tick => (
        <li
          key={tick.position}
          className={`${classes.railTick} ${tickClass[tick.position]}`}
        >
          <time dateTime={tick.instant}>{tick.label}</time>
        </li>
      ))}
    </ol>
  );
}

export function EvidenceRailLegend({ states }: { states: CockpitRailState[] }) {
  const classes = useCockpitStyles();
  return (
    <ul className={classes.railLegend} aria-label="Legenda da cobertura">
      {states.map(state => (
        <li key={state} className={classes.railLegendItem}>
          <span
            className={`${classes.railLegendMarker} ${classes[state]}`}
            aria-hidden="true"
          />
          <Typography component="span" variant="caption">
            {railStateLabel(state)}
          </Typography>
        </li>
      ))}
    </ul>
  );
}
